import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useReferencePackageBySlugQuery, useRelatedpackageDataBySlugQuery } from "../../redux/API/ReferenceApi";
import { ImgUrl, referencePackageImgUrl } from "../../constant";
import EnquiryForm from "../components/form/Enquiryform";

const RelatedPackageDetail = () => {
  const { slug } = useParams();
  const [activeTab, setActiveTab] = useState("overview");
  
  const { data } = useReferencePackageBySlugQuery(slug);
  const { data: relatedData } = useRelatedpackageDataBySlugQuery(slug);

  
  const relatedPackage = relatedData ;
  
  console.log("Printing the this  ",relatedData)
  

  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);

  function createMarkup(content) {
    const sanitizedContent = content?.replace(/<p>&nbsp;<\/p>*>/g, "");
    return { __html: sanitizedContent };
  }

  return (
    <>
      <Navbar />

      <div className="hero_banner">
        <div className="destination-detail h-100">
          <img
            src={`${ImgUrl}${referencePackageImgUrl}${relatedPackage?.data?.image}`}
            alt={relatedPackage?.name}
            className="w-100 h-100 object-fit-cover"
          />
        </div>
      </div>

      <section className="container mt-md-5 mt-sm-4">
        <div className="row">
          <div className="col-lg-9">
            <h2 data-aos="fade-up">{relatedPackage?.data?.name}</h2>
            
            {/* Navigation Tabs */}
            <div className="d-flex flex-wrap card1" data-aos="fade-up">
              {['overview', 'itinerary', 'otherInfo'].map((tab) => (
                <h6 key={tab} className="fs-6 fw-semibold detail">
                  <span
                    className="text-decoration-none me-lg-4 me-3 pb-lg-2 pb-md-2 pb-sm-1"
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      borderBottom: activeTab === tab ? "3px solid black" : "none",
                      paddingBottom: activeTab === tab ? "0.5rem" : "0",
                    }}
                    onClick={() => {
                      document.getElementById(tab)?.scrollIntoView({ behavior: "smooth" });
                      setActiveTab(tab);
                    }}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </span>
                </h6>
              ))}
            </div>

            {/* Content Sections */}
            <div className="card p-3 mb-3 mt-3" id="overview" data-aos="fade-up">
              <h4>Overview</h4>
              <div dangerouslySetInnerHTML={createMarkup(relatedPackage?.data?.overview)} />
            </div>

            <div className="card p-3 mb-3" id="itinerary" data-aos="fade-up">
              <h4>Itinerary</h4>
              <div dangerouslySetInnerHTML={createMarkup(relatedPackage?.data?.itinerary)} />
            </div>

            <div className="card p-3 mb-3" id="otherInfo" data-aos="fade-up">
              <h4>Other Information</h4>
              <div dangerouslySetInnerHTML={createMarkup(relatedPackage?.data?.otherInfo)} />
            </div>

            {/* Package Details Card */}
            <div className="card p-3" data-aos="fade-up">
              <h4>Package Details</h4>
              <div className="d-flex align-items-center">
                <div>
                  <h5 className="mb-0">Duration</h5>
                  <p>{relatedPackage?.data?.days} Days</p>
                </div>
                <div className="ms-5">
                  <h5 className="mb-0">Price</h5>
                  <p>₹{relatedPackage?.data?.price}</p>
                </div>
              </div>
              <div className="mt-3">
                <p className="mb-0">Destination: {relatedPackage?.data?.destinationId?.name}</p>
              </div>
            </div>
          </div>

          {/* Enquiry Form Section */}
          <div className="col-lg-3 mt-lg-5 mt-3 pt-2 pt-lg-5">
            <EnquiryForm 
              pid={relatedPackage?.id} 
              data-aos="fade-left"
            />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default RelatedPackageDetail;